<route>
{
  "meta": {
    "requiresAuth": true,
    "customSite": true
  }
}
</route>
<template>
  <Home />
</template>

<script>
import Home from '@implicit-web/auth/src/pages/home.vue';

export default {
  name: 'Homef',
  layout: 'channelPage',
  components: { Home },
};
</script>
